export const removeExtension = name => {
  const parts = name.split('.');
  parts.pop();
  return parts.join('.');
};
